import { useState, useEffect } from 'react';
import { publicRequest } from '../../requestMethods';
import PhonePromptModal from './PhonePromptModal';

const STORAGE_KEY_SKIPPED = 'phone_prompt_skipped';

const PhonePromptCheck = () => {
    const [showPrompt, setShowPrompt] = useState(false);
    const [user, setUser] = useState(null);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        const checkUser = () => {
            const stored = localStorage.getItem('user');
            if (!stored) {
                setUser(null);
                setShowPrompt(false);
                setChecked(true);
                return;
            }
            let parsed;
            try {
                parsed = JSON.parse(stored);
            } catch {
                setChecked(true);
                return;
            }
            setUser(parsed);

            // If user already has phone in localStorage, no prompt
            if (parsed.phone && parsed.phone.trim()) {
                setShowPrompt(false);
                setChecked(true);
                return;
            }

            // If user skipped recently (same session), don't show again immediately
            if (sessionStorage.getItem(STORAGE_KEY_SKIPPED)) {
                setShowPrompt(false);
                setChecked(true);
                return;
            }

            // Fetch profile from API to see if phone exists in DB
            publicRequest
                .get(`/users/profile?email=${encodeURIComponent(parsed.email)}`)
                .then((res) => {
                    if (res.data?.profile?.phone) {
                        const updated = { ...parsed, phone: res.data.profile.phone };
                        localStorage.setItem('user', JSON.stringify(updated));
                        window.dispatchEvent(new Event('userUpdated'));
                        setUser(updated);
                        setShowPrompt(false);
                    } else {
                        setShowPrompt(true);
                    }
                })
                .catch(() => {
                    setShowPrompt(true);
                })
                .finally(() => {
                    setChecked(true);
                });
        };

        checkUser();
        window.addEventListener('userUpdated', checkUser);
        return () => window.removeEventListener('userUpdated', checkUser);
    }, []);

    const handleClose = () => {
        sessionStorage.setItem(STORAGE_KEY_SKIPPED, '1');
        setShowPrompt(false);
    };

    const handleSaved = () => {
        setShowPrompt(false);
    };

    if (!showPrompt || !user) return null;

    return (
        <PhonePromptModal
            user={user}
            onClose={handleClose}
            onSaved={handleSaved}
        />
    );
};

export default PhonePromptCheck;
